export default {
  /* po-mo style translations start */
  "Checking the status of an application": "Checking the status of an application",
  "Here you can check the status of the application": "Here you can check the status of the application",
  'Your application is pending': 'Your application is pending',
  'Your application has been approved': 'Your application has been approved',
  'You have been denied a place in a dormitory': 'You have been denied a place in a dormitory',
  /* po-mo style translations end */

  full_name: 'Full name',
  application_reviewing: 'Your application is pending',
  application_approved: 'Your application has been approved',
  application_rejected: 'You have been denied a place in a dormitory',

  admin: {
    study_place: 'Место обучения',
    payment_method: 'Способ оплаты',
    application_status: 'Статус заявки',
    status: 'Статус заявки',
    settlement_status: 'Статус заселения',
    social_status: 'Социальный статус',
  },

  kafu: {
    title: 'Kazakh-american free university',
    description: `City University of International Partnership / State license АБ 0137478
    International accreditation ACBSP (USA) 
    / Institutional and specialized accreditation IQAA (Kazakhstan)`,
    contacts: 'Admission committee numbers',
    address: 'Dormitory address: Shakarim Avenue 160',
    phone: 'Dormitory phone: 50-50-81'
  },

  form: {
    uni_title: 'Kazakh-american free university',
    uni_description: `City University of International Partnership / State license АБ 0137478
    International accreditation ACBSP (USA) 
    / Institutional and specialized accreditation IQAA (Kazakhstan)`,
    contacts_title: 'Admission committee numbers',
    address_title: '',
    contacts_col: `
    <p>
      <a href="tel:87232500300">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        8(7232)500-300
      </a>
      <br />
      <a href="tel:87232505030">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        8(7232)50-50-30
      </a>
      <br />
      <a href="tel:77074400001">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        +7-707-440-00-01
      </a>
      <br />
    </p>
    `,
    address_col: `
    <div>Dormitory address: Shakarim Avenue 160</div>
    <div>Dormitory phone: 50-50-81</div>
    `,

    form_title: 'Dormitory application form',
    select_placeholder: 'Choose from list',
    other_placeholder: 'Other',
    choose_btn: 'Choose',
    search: 'Search',
    closed: 'Reception of applications is closed.',
    reset_btn: 'Clear',
    load_btn: 'Upload',
    cancel_btn: 'Cancel',

    personal_data_title: 'Personal information',
    contact_info_title: 'Contact information',
    additional_info_title: 'Additional information',
    vac_doc: 'Vaccination passport',
    last_name: 'Lastname',
    first_name: 'Firstname',
    middle_name: 'Middlename',
    gender: {
      title: 'Gender',
      male: 'male',
      female: 'female',
    },
    iin: 'IIN',
    study_place: 'Study place',
    payment_method: 'Payment method',
    address: 'Place of registration',
    address_tooltip:
      'Fill in as follows: Country, Region, City, Street, House, Apartment',
    address_placeholder: 'Country, Region, City, Street, House, Apartment',

    country: 'Country',
    region: 'Region',
    city: 'Name of the settlement (city, village, etc.)',
    city_placeholder: 'city of Astana',
    street: 'Street',
    house: 'House',
    flat: 'Apartment',
    private_house: 'A private house',
    uk_rejection_message: 'For persons residing in the city of Ust-Kamenogorsk, a hostel is not allocated',

    email: 'Email',
    phone: 'Contact phone',
    social_status: {
      label: 'Social status',
      title: 'Choose social status',
    },
    social_status_tooltip:
      'Select a status from the list and attach a supporting document',
    social_status_doc: 'Document confirming social status',
    submit_btn: 'Submit',
    submitted: 'Your application has been sent',

    errors: {
      first_name: 'Please enter your name!',
      last_name: 'Please enter your lastname!',
      gender: 'Indicate your gender!',
      iin: 'IIN must contain 12 digits!',
      study_place: 'Indicate the place of study!',
      payment_method: 'Specify the payment format!',
      address: 'Enter your registration address!',
      email: 'Enter your email!',
      phone: 'Enter your phone number!',
      social_status_doc: 'Attach a document confirming your social status!',
    },
  },
  article: {
    back_btn: 'Back to application form'
  }
}
